import React from 'react';
import RouterLink, { LinkProps as RouterLinkProps } from 'next/link';

export const RouteLink = React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['href'] }>((props, ref) => {
    const { href, ...other } = props;
    return <RouterLink ref={ref} href={href} {...other} />;
});
RouteLink.displayName = 'RouteLink';
